import Cookies from 'universal-cookie';
import roleManagement from './roleManagement';
import currentUserRole from './currentUserRole';

const SUPPORT_ACCESS_LEVELS = ['s1', 's2', 's3'];

/** Support sessions (accessLevel s1/s2/s3) are the support side, so they never grant access. */
export function isSupportAccessLevelUser() {
  try {
    return SUPPORT_ACCESS_LEVELS.includes(localStorage.getItem('accessLevel'));
  } catch {
    return false;
  }
}

/**
 * Whether the profile menu shows "Grant Access to Support": the role allows it, this is not a
 * support session, and access is not already granted. Fail-closed. Reads the role with
 * currentUserRole, not roleManagement.getUserRole, which logs the user out when the cookie is unreadable.
 */
export default function canShowGrantSupportAccess() {
  try {
    return (
      roleManagement.canGrantSupportAccessFromRoles(currentUserRole(), roleManagement.getUserSubRole()) &&
      !isSupportAccessLevelUser() &&
      new Cookies().get('supportAccessSt') !== '1'
    );
  } catch {
    return false;
  }
}
